import { useEffect, useState } from "react";
import api from "@/lib/api";
import MembershipPaywall from "@/components/MembershipPaywall";

const Spinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="h-10 w-10 rounded-full border-2 border-cobalt border-t-transparent animate-spin" />
  </div>
);

// Gates attorney-only pages behind an active membership. Admins always pass.
export default function MembershipGuard({ children }) {
  const [membership, setMembership] = useState(undefined);

  const load = async () => {
    try { const { data } = await api.get("/attorney/membership"); setMembership(data); }
    catch { setMembership({ active: true, is_admin: false }); }  // fail-open on transient error
  };
  useEffect(() => { load(); }, []);

  if (membership === undefined) return <Spinner />;
  if (membership.is_admin || membership.active) return children;
  return <MembershipPaywall membership={membership} onRefresh={load} />;
}
